import { createAsyncThunk } from "@reduxjs/toolkit";
import { initializedActions } from "./initial-app-slice";
import responseErrorMessage from "../assets/helpers/responseMessage";
import { PermissionRoles } from "../models/models";

export interface ResponseData {
    id: number;
    userName: string;
    role: string;
    token: string;
    permissions?: string[] | null;
}

export interface AuthData {
    id: number;
    token: string;
    userName: string;
    role: PermissionRoles;
    permissions: string[];
    isAuth: true;
}
export interface MyKnownError {
    message: string;
}

export const logout = createAsyncThunk(
    "auth/logout",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            // const response = await fetch(`https://api/User/delete`, {
            //     method: "DELETE",
            //     headers: {
            //         "Content-Type": "application/json"
            //     }
            // })
            // if (!response.ok) {
            //     throw new Error("Error logging out");
            // }
        } catch (error: any) {
            return rejectWithValue(error.message as MyKnownError);
        }
    }
);

export const fetchAuthToken = createAsyncThunk<
    AuthData,
    { name: string; password: string },
    {
        rejectValue: MyKnownError;
    }
>(
    "auth/fetchAuthToken",
    async (data, { rejectWithValue, dispatch, getState }) => {
        // first argument is the type returned this Thunk
        // first argument is the argument when creating the async function, second thunkApi
        // const state = getState().auth. // get data from the state object

        const { name, password } = data;

        // console.log(`name:${name}, password${password}`);
        try {
            const sendRequest = async () => {
                const response = await fetch(
                    `https://${
                        process.env.REACT_APP_DEPLOY_PLATFORM === "stage"
                            ? "stage-"
                            : ""
                    }license.adaware.com/api/User/login`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            username: name,
                            password: password,
                        }),
                    }
                );

                if (!response.ok) {
                    let error: MyKnownError = {
                        message: "",
                    };

                    if (response.status === 400) {
                        error.message = "Username or password incorrect!";
                    } else {
                        error.message = responseErrorMessage(response.status);
                    }

                    throw error;
                }

                return await response.json();
            };

            const resData = await sendRequest();

            resData.isAuth = true;

            localStorage.setItem("auth", JSON.stringify({ ...resData }));

            dispatch(
                initializedActions.initializedSuccess({
                    userId: resData.id,
                    token: resData.token,
                    userName: resData.userName,
                    role: resData.role,
                    permissions: resData.permissions ?? [],
                    initialized: true,
                    theme: "dark",
                })
            );

            return resData;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);
